const formEndpoint = (...props) => ['', ...props].join('/');

const formV1Endpoint = (...props) => formEndpoint('v1', ...props);
const formV2Endpoint = (...props) => formEndpoint('v2', ...props);

const formV1ConsoleEndpoint = (...props) => formV1Endpoint('console', ...props);
const formV2ConsoleEndpoint = (...props) => formV2Endpoint('console', ...props);

// ---------------AUTH

const formV1AuthEndpoint = (...props) => formV1Endpoint('auth', ...props);
const formV2AuthEndpoint = (...props) => formV2Endpoint('auth', ...props);

const formV2UserEndpoint = (...props) => formV2Endpoint('console', 'user', 'group', ...props);

export const ENDPOINT_ACCOUNT_SUBACCCOUNTS_LIST = formV2UserEndpoint('list');
export const ENDPOINT_ACCOUNT_SWITCH = formV2UserEndpoint('switch');

export const ENDPOINT_ACCOUNT_AVATAR = formV1ConsoleEndpoint('avatar');
export const ENDPOINT_AUTH_SIGN_UP = formV2AuthEndpoint('sign-up', 'merchant');
export const ENDPOINT_AUTH_SIGN_IN = formV1AuthEndpoint('sign-in', 'console');
export const ENDPOINT_AUTH_SIGN_OUT = formV1AuthEndpoint('sign-out');

export const ENDPOINT_AUTH_SWITCH = formV1AuthEndpoint('change-site');

export const ENDPOINT_AUTH_PWD_RECOVERY = formV1AuthEndpoint('password-recovery', 'console');
export const ENDPOINT_AUTH_RECOVERY_TOKEN = formV1AuthEndpoint('recovery-token', 'console');

export const ENDPOINT_AUTH_USER = formV1AuthEndpoint('user');

export const ENDPOINT_AUTH_EMAIL_CONFIRM = formV1AuthEndpoint('email', 'confirm');
export const ENDPOINT_AUTH_EMAIL_RESEND = formV2AuthEndpoint('email', 'resend_confirmation');

export const ENDPOINT_AUTH_TFA_BIND = formV1AuthEndpoint('tfa', 'bind');
export const ENDPOINT_AUTH_TFA_CONFIRM = formV1AuthEndpoint('tfa', 'confirm');
export const ENDPOINT_AUTH_TFA_VERIFY = formV1AuthEndpoint('tfa', 'verify');

// ---------------REGISTRATION

const formV2KYCEndpoint = (...props) => formV2Endpoint('kyc', ...props);
const formV2KYCSubmitEndpoint = (path) => formV2KYCEndpoint(path, 'submit');
const formV2KYCOwnerEndpoint = (...props) => formV2KYCEndpoint('owner', ...props);

export const ENDPOINT_KYC_STATUS = formV2KYCEndpoint('status');

export const ENDPOINT_KYC_COMPANY_SUBMIT = formV2KYCSubmitEndpoint('company-profile');
export const ENDPOINT_KYC_PERSONAL_SUBMIT = formV2KYCSubmitEndpoint('personal-profile');
export const ENDPOINT_KYC_BANK_SUBMIT = formV2KYCSubmitEndpoint('bank');

export const ENDPOINT_KYC_DOCUMENTS_SUBMIT = formV2KYCSubmitEndpoint('document');
export const ENDPOINT_KYC_DOCUMENTS_REMOVE = formV2KYCEndpoint('document', 'remove');
export const ENDPOINT_DOCUMENTS_UPLOAD_DEFAULT = formV2Endpoint('doc', 'upload');

export const ENDPOINT_KYC_OWNER_CREATE = formV2KYCOwnerEndpoint('create');
export const ENDPOINT_KYC_OWNER_UPDATE = formV2KYCOwnerEndpoint('update');
export const ENDPOINT_KYC_OWNER_REMOVE = formV2KYCOwnerEndpoint('remove');

// ---------------MERCHANT

// Account

export const ENDPOINT_PASSWORD_SAVE = formV2ConsoleEndpoint('password', 'set');

// Asset Amount

export const ENDPOINT_ASSETS_AMOUNT_LIST = formV2ConsoleEndpoint('assets', 'amount');
export const ENDPOINT_KLUB_FEE_AMOUNT = formV2ConsoleEndpoint('klub', 'fee-amount');
export const ENDPOINT_NCDT_FEE_AMOUNT = formV2ConsoleEndpoint('ncdt', 'fee-amount');
export const ENDPOINT_ASSETS_AMOUNT_LIMITS = formV2ConsoleEndpoint('withdraw', 'limits');

// Bank

const formV2BankEndpoint = (...props) => formV2ConsoleEndpoint('bank', ...props);

export const ENDPOINT_MERCHANT_BANKS_LIST = formV2BankEndpoint('list');
export const ENDPOINT_MERCHANT_BANK_DETAILS = formV2BankEndpoint('get');
export const ENDPOINT_MERCHANT_BANK_CREATE = formV2BankEndpoint('create');
export const ENDPOINT_MERCHANT_BANK_UPDATE = formV2BankEndpoint('update');
export const ENDPOINT_MERCHANT_BANK_SET_PRIMARY = formV2BankEndpoint('set-primary');
export const ENDPOINT_MERCHANT_BANK_REMOVE = formV2BankEndpoint('remove');

// AML

const formV2MerchantAmlEndpoint = (...props) => formV2ConsoleEndpoint('buyer-aml-preference', ...props);

export const ENDPOINT_MERCHANT_AML_SET = formV2MerchantAmlEndpoint('set');
export const ENDPOINT_MERCHANT_AML_GET = formV2MerchantAmlEndpoint('get');

// Notification

const formV2MerchantNotifEndpoint = (...props) => formV2ConsoleEndpoint('notification', ...props);

export const ENDPOINT_MERCHANT_NOTIF_SET = formV2MerchantNotifEndpoint('set');
export const ENDPOINT_MERCHANT_NOTIF_GET = formV2MerchantNotifEndpoint('get');

// Pay By Link

const formV2MerchantPblEndpoint = (...props) => formV2ConsoleEndpoint('paybylink', ...props);

export const ENDPOINT_MERCHANT_PBL_LIST = formV2MerchantPblEndpoint('list');
export const ENDPOINT_MERCHANT_PBL_DETAILS = formV2MerchantPblEndpoint('get');
export const ENDPOINT_MERCHANT_PBL_CUSTOMERS = formV2MerchantPblEndpoint('customers');
export const ENDPOINT_MERCHANT_PBL_CREATE = formV2MerchantPblEndpoint('create');
export const ENDPOINT_MERCHANT_PBL_UPDATE = formV2MerchantPblEndpoint('update');
export const ENDPOINT_MERCHANT_PBL_SEND = formV2MerchantPblEndpoint('send');
export const ENDPOINT_MERCHANT_PBL_REMOVE = formV2MerchantPblEndpoint('attach', 'remove');
export const ENDPOINT_MERCHANT_PBL_LIMITS = formV2MerchantPblEndpoint('limits');
export const ENDPOINT_MERCHANT_PBL_CANCEL = formV2MerchantPblEndpoint('cancel');

export const ENDPOINT_MERCHANT_NEXT_INVOICE_ID = formV2ConsoleEndpoint('get-next-invoice-number');
export const ENDPOINT_MERCHANT_INVOICE_DOC_UPLOAD = formV1Endpoint('invoice', 'doc', 'upload');

// Refund

const formV2MerchantRefundEndpoint = (...props) => formV2ConsoleEndpoint('refund', ...props);

export const ENDPOINT_MERCHANT_REFUND_CANCEL = formV2MerchantRefundEndpoint('cancel');
export const ENDPOINT_MERCHANT_REFUND_UPDATE = formV2MerchantRefundEndpoint('update');
export const ENDPOINT_MERCHANT_REFUND_DETAILS = formV2MerchantRefundEndpoint('get');

// Settlement period

const formV2MerchantSettlementEndpoint = (...props) => formV2ConsoleEndpoint('settlement-refund-period', ...props);

export const ENDPOINT_MERCHANT_SETTLEMENT_GET = formV2MerchantSettlementEndpoint('get');
export const ENDPOINT_MERCHANT_SETTLEMENT_SET = formV2MerchantSettlementEndpoint('set');

// Stablecoin

const formV2MerchantSCEndpoint = (...props) => formV2ConsoleEndpoint('stablecoin', ...props);

export const ENDPOINT_MERCHANT_SC_LIST = formV2MerchantSCEndpoint('list');
export const ENDPOINT_MERCHANT_SC_DETAILS = formV2MerchantSCEndpoint('get');
export const ENDPOINT_MERCHANT_SC_CREATE = formV2MerchantSCEndpoint('create');
export const ENDPOINT_MERCHANT_SC_UPDATE = formV2MerchantSCEndpoint('update');
export const ENDPOINT_MERCHANT_SC_REMOVE = formV2MerchantSCEndpoint('remove');

// Terminal

const formV1MerchantTerminalEndpoint = (...props) => formV1ConsoleEndpoint('terminals', ...props);
const formV2MerchantTerminalEndpoint = (...props) => formV2ConsoleEndpoint('terminals', ...props);

export const ENDPOINT_MERCHANT_TERMINALS_LIST = formV2MerchantTerminalEndpoint('list');
export const ENDPOINT_MERCHANT_TERMINAL_EDIT = formV2MerchantTerminalEndpoint('edit');
export const ENDPOINT_MERCHANT_TERMINAL_REMOVE = formV1MerchantTerminalEndpoint('remove');
export const ENDPOINT_MERCHANT_TERMINAL_ORDER = formV2MerchantTerminalEndpoint('order');

export const ENDPOINT_MERCHANT_TERMINAL_NOTIF = formV2ConsoleEndpoint('mpos_sales_notification', 'set');

// Transactions

const formV2MerchantTrxEndpoint = (...props) => formV2ConsoleEndpoint('transaction', ...props);

export const ENDPOINT_MERCHANT_TRX_LIST = formV2MerchantTrxEndpoint('list');
export const ENDPOINT_MERCHANT_TRX_DETAILS = formV2MerchantTrxEndpoint('get');
export const ENDPOINT_MERCHANT_TRX_REFUND = formV2MerchantTrxEndpoint('refund');

// User

const formV2MerchantUserEndpoint = (...props) => formV2ConsoleEndpoint('user', ...props);

export const ENDPOINT_MERCHANT_USERS_LIST = formV2MerchantUserEndpoint('list');
export const ENDPOINT_MERCHANT_USER_CREATE = formV2MerchantUserEndpoint('create');
export const ENDPOINT_MERCHANT_USER_UPDATE = formV2MerchantUserEndpoint('update');
export const ENDPOINT_MERCHANT_USER_REMOVE = formV2MerchantUserEndpoint('remove');
export const ENDPOINT_MERCHANT_USER_SEND_INVITE = formV2MerchantUserEndpoint('invite', 'send');

// Withdraw

const formV2MerchantWithdrawEndpoint = (...props) => formV2ConsoleEndpoint('withdraw', ...props);
const formV2MerchantSCWithdrawEndpoint = (...props) => formV2ConsoleEndpoint('stablecoin', 'withdraw', ...props);

export const ENDPOINT_MERCHANT_WD_CREATE = formV2MerchantWithdrawEndpoint('create');
export const ENDPOINT_MERCHANT_SC_WD_CREATE = formV2MerchantSCWithdrawEndpoint('create');
export const ENDPOINT_MERCHANT_WD_LIST = formV2MerchantWithdrawEndpoint('list');
export const ENDPOINT_MERCHANT_WD_GET = formV2MerchantWithdrawEndpoint('get');

// App

const formV1MerchantAppEndpoint = (...props) => formV1ConsoleEndpoint('app', ...props);
const formV1MerchantAppNotifEndpoint = (...props) => formV1MerchantAppEndpoint('notification-http-header', ...props);

export const ENDPOINT_MERCHANT_APPS_LIST = formV1MerchantAppEndpoint('list');
export const ENDPOINT_MERCHANT_APP_DETAILS = formV1MerchantAppEndpoint('get');
export const ENDPOINT_MERCHANT_APP_ADD = formV1MerchantAppEndpoint('add');
export const ENDPOINT_MERCHANT_APP_EDIT = formV1MerchantAppEndpoint('edit');
export const ENDPOINT_MERCHANT_APP_REMOVE = formV1MerchantAppEndpoint('remove');

export const ENDPOINT_MERCHANT_APP_NOTIF_LIST = formV1MerchantAppNotifEndpoint('list');
export const ENDPOINT_MERCHANT_APP_NOTIF_ADD = formV1MerchantAppNotifEndpoint('add');
export const ENDPOINT_MERCHANT_APP_NOTIF_UPDATE = formV1MerchantAppNotifEndpoint('update');
export const ENDPOINT_MERCHANT_APP_NOTIF_DELETE = formV1MerchantAppNotifEndpoint('delete');

// Klubcoin Fees

export const ENDPOINT_MERCHANT_KLUBCOIN_FEES_LIST = formV2ConsoleEndpoint('invoice-fees', 'list');

// Promo ??????

const formV2MerchantPromoEndpoint = (...props) => formV2ConsoleEndpoint('promo', ...props);

export const ENDPOINT_MERCHANT_PROMO_DETAILS = formV2MerchantPromoEndpoint('get');
export const ENDPOINT_MERCHANT_PROMO_CREATE = formV2MerchantPromoEndpoint('create');
export const ENDPOINT_MERCHANT_PROMO_UPDATE = formV2MerchantPromoEndpoint('update');

// Sales Notifications ?????

const formV2MerchantSalesNotifEndpoint = (...props) => formV2ConsoleEndpoint('sales_notification', ...props);

export const ENDPOINT_MERCHANT_SALES_NOTIF_SET = formV2MerchantSalesNotifEndpoint('set');
export const ENDPOINT_MERCHANT_SALES_NOTIF_GET = formV2MerchantSalesNotifEndpoint('get');

// Settings

const formV2MerchantSettingsEndpoint = (...props) => formV2ConsoleEndpoint('settings', ...props);

export const ENDPOINT_MERCHANT_SETTINGS_SET = formV2MerchantSettingsEndpoint('set');
export const ENDPOINT_MERCHANT_SETTINGS_LIST = formV2MerchantSettingsEndpoint('list');
export const ENDPOINT_MERCHANT_AVATAR_UPLOAD = formV1ConsoleEndpoint('avatar', 'upload');

// Help

export const ENDPOINT_MERCHANT_HELP = formV2ConsoleEndpoint('help', 'ask');

// ---------------REFERRAL

const formV2RefEndpoint = (...props) => formV2Endpoint('referral-api', 'partner', ...props);

// Dashboard

export const ENDPOINT_REF_PARTNER_TRX_COUNT = formV2RefEndpoint('transactions-counters');
export const ENDPOINT_REF_PARTNER_STATS = formV2RefEndpoint('referral-stats');

// Merchant

export const ENDPOINT_REF_MERCH_LIST = formV2RefEndpoint('merchants', 'list');
export const ENDPOINT_REF_MERCH_REG = formV2RefEndpoint('register-merchant');

// Payouts

export const ENDPOINT_REF_PAYOUTS = formV2ConsoleEndpoint('referral', 'payouts');

// Trx

export const ENDPOINT_REF_TRX_STATS = formV2RefEndpoint('merchant-statistic', 'list');
export const ENDPOINT_REF_TRX_LIST = formV2RefEndpoint('payments', 'list');

// ---------------ADMIN

const formV1AdminEndpoint = (...props) => formV1Endpoint('admin', ...props);

// Finery

const formV1AdminFineryEndpoint = (...props) => formV1AdminEndpoint('finery', ...props);
const formV1AdminSettlementsEndpoint = (...props) => formV1AdminFineryEndpoint('settlements', ...props);

export const ENDPOINT_ADMIN_FINERY = formV1AdminFineryEndpoint('positions');
export const ENDPOINT_ADMIN_SETTLEMENTS = formV1AdminSettlementsEndpoint();
export const ENDPOINT_ADMIN_SETTLEMENTS_CREATE = formV1AdminSettlementsEndpoint('create');
export const ENDPOINT_ADMIN_SETTLEMENTS_SEND = formV1AdminSettlementsEndpoint('send');
export const ENDPOINT_ADMIN_SETTLEMENTS_REMOVE = formV1AdminSettlementsEndpoint('del');

// Refunds

const formV1AdminRefundEndpoint = (...props) => formV1AdminEndpoint('refund', ...props);
const formV1AdminCustomerIssueEndpoint = (...props) => formV1AdminEndpoint('customer-issue', ...props);

export const ENDPOINT_ADMIN_REFUNDS_LIST = formV1AdminRefundEndpoint('list');
export const ENDPOINT_ADMIN_REFUND_UPDATE = formV1AdminRefundEndpoint('update');

export const ENDPOINT_ADMIN_CI_LIST = formV1AdminCustomerIssueEndpoint('list');
export const ENDPOINT_ADMIN_CI_ADD = formV1AdminCustomerIssueEndpoint('add');
export const ENDPOINT_ADMIN_CI_UPDATE = formV1AdminCustomerIssueEndpoint('update');
export const ENDPOINT_ADMIN_CI_DECLINE = formV1AdminCustomerIssueEndpoint('decline');
export const ENDPOINT_ADMIN_CI_REFUND = formV1AdminCustomerIssueEndpoint('refund');
export const ENDPOINT_ADMIN_CI_REFUND_STATUS = formV1AdminCustomerIssueEndpoint('refund-status');
export const ENDPOINT_ADMIN_CI_ENROLL = formV1AdminCustomerIssueEndpoint('enroll');

// Stable Coins Withdraws

const formV1AdminSCWEndpoint = (...props) => formV1AdminEndpoint('stablecoin-withdraw', ...props);

export const ENDPOINT_ADMIN_SCW_LIST = formV1AdminSCWEndpoint('list');
export const ENDPOINT_ADMIN_SCW_UPDATE = formV1AdminSCWEndpoint('update');

// Accounts

const formV1AdminAccEndpoint = (...props) => formV1AdminEndpoint('accounts', ...props);
const formV1AdminAccKYCEndpoint = (...props) => formV1AdminEndpoint('kyc', 'account', ...props);

export const ENDPOINT_ADMIN_ACC_LIST = formV1AdminAccEndpoint('list');
export const ENDPOINT_ADMIN_ACC_SUBMERCHANT_CREATE = formV1AdminEndpoint('account', 'submerchant', 'create');
export const ENDPOINT_ADMIN_ACC_SUBMERCHANT_UPDATE = formV1AdminEndpoint('account', 'submerchant', 'update');

export const ENDPOINT_ADMIN_KYC_LIST = formV1AdminAccKYCEndpoint('list');
export const ENDPOINT_ADMIN_KYC_DETAILS = formV1AdminAccKYCEndpoint('get');
export const ENDPOINT_ADMIN_KYC_UPDATE = formV1AdminAccKYCEndpoint('verification_state', 'update');

export const ENDPOINT_ADMIN_KYC_DOWNLOAD = formV1Endpoint('doc', 'download');

// Auctions

export const ENDPOINT_ADMIN_ACTIVE_AUCS_LIST = formV1AdminEndpoint('active-auctions', 'list');

export const ENDPOINT_ADMIN_AUCS_LIST = formV1AdminEndpoint('auctions', 'list');
export const ENDPOINT_ADMIN_AUC_STATUS_CHANGE = formV1AdminEndpoint('auction', 'confirm');
export const ENDPOINT_ADMIN_AUC_CREATE = formV1AdminEndpoint('auction', 'create-confirm');

// CC Codes

const formV1AdminCCCodeEndpoint = (...props) => formV1AdminEndpoint('cccode', ...props);

export const ENDPOINT_ADMIN_CC_CODES_LIST = formV1AdminCCCodeEndpoint('list');
export const ENDPOINT_ADMIN_CC_CODE_ACTIVATE = formV1AdminCCCodeEndpoint('activate');

// Klubcoin Fees

const formV1AdminKlubcoinFeesEndpoint = (...props) => formV1AdminEndpoint('fee-invoice', ...props);

export const ENDPOINT_ADMIN_KC_FEES_LIST = formV1AdminKlubcoinFeesEndpoint('list');
export const ENDPOINT_ADMIN_KC_FEES_CONFIRM = formV1AdminKlubcoinFeesEndpoint('confirm');

// Mailsystem | Mailsender

export const ENDPOINT_ADMIN_MS_STATE = formV1AdminEndpoint('mailsystem', 'state');
export const ENDPOINT_ADMIN_MS_RUN = formV1AdminEndpoint('mailsender', 'run');
export const ENDPOINT_ADMIN_MS_PAUSE = formV1AdminEndpoint('mailsender', 'pause');

// Maintenance

const formV1AdminMaintenanceEndpoint = (...props) => formV1AdminEndpoint('maintenance', ...props);

export const ENDPOINT_ADMIN_MAINTENANCE_GET = formV1AdminMaintenanceEndpoint('get');
export const ENDPOINT_ADMIN_MAINTENANCE_ENABLE = formV1AdminMaintenanceEndpoint('enable');
export const ENDPOINT_ADMIN_MAINTENANCE_DISABLE = formV1AdminMaintenanceEndpoint('disable');

// Master Merchant

const formV1AdminMasterMerchantEndpoint = (...props) => formV2Endpoint('referral-api', 'admin', ...props);

export const ENDPOINT_ADMIN_MASTER_MERCHANT_CREATE = formV1AdminMasterMerchantEndpoint('create_referral');
export const ENDPOINT_ADMIN_MASTER_MERCHANT_STATUS = formV1AdminMasterMerchantEndpoint('referral_partner');

// Merchant

const formV1AdminMerchantEndpoint = (...props) => formV1AdminEndpoint('merchant', ...props);

export const ENDPOINT_ADMIN_MERCHANT_SET_LIMITS = formV1AdminMerchantEndpoint('set-limits');
export const ENDPOINT_ADMIN_MERCHANT_FILTER = formV1AdminMerchantEndpoint('filter');

// MPOS Users

const formV1AdminBranchEndpoint = (...props) => formV1AdminEndpoint('branch', ...props);

export const ENDPOINT_ADMIN_BRANCH_LIST = formV1AdminBranchEndpoint('list');
export const ENDPOINT_ADMIN_BRANCH_CREATE = formV1AdminBranchEndpoint('create');
export const ENDPOINT_ADMIN_BRANCH_UPDATE = formV1AdminBranchEndpoint('update');
export const ENDPOINT_ADMIN_BRANCH_DELETE = formV1AdminBranchEndpoint('delete');

// Statistic (dashboard)

const formV1AdminDashboardEndpoint = (...props) => formV1AdminEndpoint('dashboard', ...props);

export const ENDPOINT_ADMIN_STATS_MONTHLY = formV1AdminDashboardEndpoint('monthly-payments-overview');
export const ENDPOINT_ADMIN_STATS_PAYMENTS = formV1AdminDashboardEndpoint('payments-overview');
export const ENDPOINT_ADMIN_STATS_PENDING_WITHDRAWS = formV1AdminDashboardEndpoint('pending-withdrawals-overview');

// Status (dashboard)

const formV1AdminStatusEndpoint = (...props) => formV1AdminEndpoint('status', ...props);

export const ENDPOINT_ADMIN_STATUS_LIST = formV1AdminStatusEndpoint('list');
export const ENDPOINT_ADMIN_STATUS_GET = formV1AdminStatusEndpoint('get');
export const ENDPOINT_ADMIN_STATUS_RESTART = formV1AdminStatusEndpoint('restart');

// Status (dashboard)

const formV1AdminTerminalsEndpoint = (...props) => formV1AdminEndpoint('terminals', ...props);

export const ENDPOINT_ADMIN_TERMINALS_LIST = formV1AdminTerminalsEndpoint('list');
export const ENDPOINT_ADMIN_TERMINALS_DETAILS = formV1AdminTerminalsEndpoint('get');
export const ENDPOINT_ADMIN_TERMINALS_ADD = formV1AdminTerminalsEndpoint('add');
export const ENDPOINT_ADMIN_TERMINALS_UPDATE = formV1AdminTerminalsEndpoint('update');
export const ENDPOINT_ADMIN_TERMINALS_REMOVE = formV1AdminTerminalsEndpoint('remove');
export const ENDPOINT_ADMIN_TERMINALS_BIND = formV1AdminTerminalsEndpoint('bind-credentials');
export const ENDPOINT_ADMIN_TERMINALS_SET_LOGOUT = formV1AdminTerminalsEndpoint('set-need-logout');

// Wallets (dashboard)

const formV1AdminWalletEndpoint = (...props) => formV1AdminEndpoint('wallet', ...props);

export const ENDPOINT_ADMIN_WALLET_LIST = formV1AdminWalletEndpoint('list');
export const ENDPOINT_ADMIN_WALLET_ACTIVATE = formV1AdminWalletEndpoint('activate');

// Payouts

const formV1AdminPayoutEndpoint = (...props) => formV1AdminEndpoint('payout', ...props);
const formV1AdminPONiumEndpoint = (...props) => formV1AdminPayoutEndpoint('nium', ...props);
const formV1AdminPOVertoEndpoint = (...props) => formV1AdminPayoutEndpoint('verto', ...props);

export const ENDPOIN_ADMIN_PO_GET = formV1AdminEndpoint('payout-group', 'get');
export const ENDPOIN_ADMIN_PO_CANDIDATES = formV1AdminPayoutEndpoint('candidates');

export const ENDPOINT_ADMIN_PO_KRAKEN_START = formV1AdminPayoutEndpoint('start', 'kraken-nium');
export const ENDPOINT_ADMIN_PO_KRAKEN_UPDATE = formV1AdminPayoutEndpoint('kraken', 'manual-update');
export const ENDPOINT_ADMIN_PO_KRAKEN_REFRESH = formV1AdminPayoutEndpoint('kraken', 'manual-refresh-transaction');

export const ENDPOINT_ADMIN_PO_NIUM_LIST = formV1AdminPONiumEndpoint('group-list');
export const ENDPOINT_ADMIN_PO_NIUM_DETAILS = formV1AdminPONiumEndpoint('get');
export const ENDPOINT_ADMIN_PO_NIUM_CREATE = formV1AdminPONiumEndpoint('create');
export const ENDPOINT_ADMIN_PO_NIUM_UPDATE = formV1AdminPONiumEndpoint('manual-update');
export const ENDPOINT_ADMIN_PO_NIUM_DIRECT = formV1AdminPONiumEndpoint('direct');
export const ENDPOINT_ADMIN_PO_NIUM_REFRESH = formV1AdminPONiumEndpoint('manual-refresh-transaction');

export const ENDPOINT_ADMIN_PO_NIUM_BENEFICIARY_ADD = formV1AdminPONiumEndpoint('beneficiary', 'add');
export const ENDPOINT_ADMIN_PO_NIUM_BENEFICIARY_GET = formV1AdminPONiumEndpoint('beneficiary', 'get');

export const ENDPOINT_ADMIN_PO_NIUM_REMITTER_ADD = formV1AdminPONiumEndpoint('remitter', 'add');
export const ENDPOINT_ADMIN_PO_NIUM_REMITTER_UPDATE = formV1AdminPONiumEndpoint('remitter', 'update');
export const ENDPOINT_ADMIN_PO_NIUM_REMITTER_LIST = formV1AdminPONiumEndpoint('remitter', 'list');
export const ENDPOINT_ADMIN_PO_NIUM_REMITTER_GET = formV1AdminPONiumEndpoint('remitter', 'get');

export const ENDPOINT_ADMIN_PO_VERTO_GET = formV1AdminPOVertoEndpoint('get');
export const ENDPOINT_ADMIN_PO_VERTO_CANCEL = formV1AdminPOVertoEndpoint('cancel');
export const ENDPOINT_ADMIN_PO_VERTO_UPDATE = formV1AdminPOVertoEndpoint('manual-update');
export const ENDPOINT_ADMIN_PO_VERTO_CREATE = formV1AdminPOVertoEndpoint('individual-create');
export const ENDPOINT_ADMIN_PO_VERTO_LIST = formV1AdminPOVertoEndpoint('list');

export const ENDPOINT_ADMIN_BANKING_ACC = formV1AdminEndpoint('bank-account');

// etc (single urls)

export const ENDPOINT_ADMIN_WITHDRAWS_LIST = formV1AdminEndpoint('withdraws', 'list');
export const ENDPOINT_ADMIN_ARBITRAGE_DEPOSITS_LIST = formV1AdminEndpoint('arbitrage-deposits', 'list');
export const ENDPOINT_ADMIN_COMMISSIONS_LIST = formV1AdminEndpoint('commissions', 'list');
export const ENDPOINT_ADMIN_DEPS_STATUSES_LIST = formV1AdminEndpoint('deposits-status', 'list');
export const ENDPOINT_ADMIN_EARNED_MONEYS_LIST = formV1AdminEndpoint('earned-money', 'list');
export const ENDPOINT_ADMIN_EXCHANGE_DEPOSITS_LIST = formV1AdminEndpoint('exchange-deposits', 'list');
export const ENDPOINT_ADMIN_EXCHANGE_ORDERS_LIST = formV1AdminEndpoint('exchange-orders', 'list');
export const ENDPOINT_ADMIN_EXCHANGE_RATES_LIST = formV1AdminEndpoint('exchange-rates', 'list');
export const ENDPOINT_ADMIN_FAILED_AUCTIONS_LIST = formV1AdminEndpoint('failed-auction', 'list');
export const ENDPOINT_ADMIN_MERCHANT_STATISTIC_LIST = formV1AdminEndpoint('merchant-statistic', 'list');
export const ENDPOINT_ADMIN_ORACLES_LIST = formV1AdminEndpoint('oraclesc', 'list');
export const ENDPOINT_ADMIN_ORDERED_TERMINALS_LIST = formV1AdminEndpoint('ordered-terminals', 'list');
export const ENDPOINT_ADMIN_TRX_COLLISIONS_LIST = formV1AdminEndpoint('transaction-collision', 'list');
export const ENDPOINT_ADMIN_TRX_LIST = formV1AdminEndpoint('transactions', 'list');












